/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IconUploadConfirmDialog } from 'app/components/icon-upload-confirm-dialog.component';
import { Observable } from 'rxjs';
import { ServerObjectService } from './server-object.service';

@Injectable({
  providedIn: 'root'
})
export class IconUploadConfirmDialogService {

  constructor(private modalService: NgbModal, private serverObjectService: ServerObjectService) { }

    public show(): Promise<boolean> {
      const modalRef = this.modalService.open(IconUploadConfirmDialog, {size: 'sm', animation: true});
      return modalRef.result;
  }


}
